/**
 * Display labels and canonical orderings for the capabilities modal.
 *
 * ORDER MATTERS: the filter chips are derived from the tools actually present,
 * but they are rendered in the order declared here — not in whatever order the
 * tool list happens to arrive in — so the chip row is stable across roles and
 * feature flags.
 */

export const ALL_KEY = 'all';

export const CATEGORY_LABELS: Record<string, string> = {
  lookup: 'Lookup',
  search: 'Search',
  list: 'List',
  create: 'Create',
  edit: 'Edit',
  communicate: 'Communicate',
  integrations: 'Integrations',
};

export const USE_CASE_LABELS: Record<string, string> = {
  operations: 'Operations',
  sales: 'Sales',
  marketing: 'Marketing',
  general: 'General',
};

export const ENTITY_LABELS: Record<string, string> = {
  contact: 'Contact',
  company: 'Company',
  employee: 'Employee',
  ticket: 'Ticket',
  time_entry: 'Time entry',
  activity: 'Activity',
  email: 'Email',
  calendar: 'Calendar',
  drive: 'Drive',
  quickbooks: 'QuickBooks',
  web: 'Web',
  deal: 'Deal',
  task: 'Task',
  offering: 'Offering',
  msp_doc: 'MSP Doc',
  recurring_transaction: 'Recurring Transaction',
  social: 'Social',
  contract: 'Contract',
  slack: 'Slack',
};

export const ROLE_LABELS: Record<string, string> = {
  wtc_admin: 'Admin',
  wtc_employee: 'Employee',
  wtc_crm: 'CRM User',
};

export const USE_CASE_ORDER: readonly string[] = ['operations', 'sales', 'marketing', 'general'];

export const ENTITY_ORDER: readonly string[] = [
  'contact',
  'company',
  'employee',
  'ticket',
  'time_entry',
  'activity',
  'email',
  'calendar',
  'drive',
  'quickbooks',
  'web',
  'deal',
  'task',
  'offering',
  'msp_doc',
  'recurring_transaction',
  'social',
  'contract',
  'slack',
];
